import { useEffect, useMemo } from 'react';
import { useT } from '../../i18n/i18n';
import { billingStore, ensureBillingStarted, inspectionsOpenElsewhere } from '../../state/billingStore';
import { useStore } from '../../state/createStore';
import { inspectionStore } from '../../state/inspectionStore';
import { Banner } from '../../ui/components';
import { formatDate } from '../../ui/hooks';

// 「另一台设备上还有 N 单没做完」 (Owner 2026-10-20, billingPolicy.ts V-2): the formal inspections this account has
// open on another device — the server knows where each one lives, never what is in it — so a missing
// inspection is never mistaken for a lost one. Says how to bring one here: export it there, import it here.
export function OtherDevicesBanner() {
  const { t, tp, locale } = useT();
  const billing = useStore(billingStore, (s) => s);
  const localIds = useStore(inspectionStore, (s) => s.inspections.map((i) => i.id).join('\n'));
  const elsewhere = useMemo(() => inspectionsOpenElsewhere(billing, new Set(localIds.split('\n').filter((id) => id.length > 0))), [billing, localIds]);
  // The account's records come with the billing answer: ask for it here too, not only from Home.
  useEffect(() => {
    void ensureBillingStarted().catch(() => undefined);
  }, []);
  if (elsewhere.length === 0) return null;
  const separator = locale === 'zh-CN' ? '；' : '; ';
  const list = elsewhere
    .slice(0, 3)
    .map((record) => t('otherDevices.item', { device: record.holder?.label || t('otherDevices.someDevice'), date: formatDate(record.at) }))
    .join(separator);
  return (
    <div className="banner-slot">
      <Banner tone="info" icon="devices" title={tp('otherDevices.title', elsewhere.length)} body={t('otherDevices.body', { list: elsewhere.length > 3 ? `${list}${separator}…` : list })} testId="other-devices" />
    </div>
  );
}
